export const socialsData = {
  github: "https://github.com/R-Yaduvanshi",
  linkedIn: "https://www.linkedin.com/in/r-yadav",
};
